import { FC, useEffect, useRef, useState } from 'react'

import { FilterAccordion, useOnClickOutside, useOnKeyDown } from '@avantstay/backoffice-core'

import { ToggleField } from '@new/__ui/ToggleField'
import { ToggleBooleanType } from '@new/__ui/ToggleField/ToggleField.types'

import { FiltersSharedProps } from '../Filters.types'

interface ToggleBasedFilterProps extends FiltersSharedProps {
  title: string
  initialValue?: boolean
  onChange: (value?: boolean) => void
}

export const ToggleBasedFilter: FC<ToggleBasedFilterProps> = ({
  title,
  initialValue,
  isSidebarFilter,
  onChange,
}) => {
  const [localValue, setLocalValue] = useState<boolean | undefined>(initialValue)

  const wrapperRef = useRef<HTMLDivElement>(null)

  const enterWasPressed = useOnKeyDown('enter')

  const handleSubmitValue = () => {
    if (localValue !== initialValue) {
      onChange(localValue)
    }
  }

  useOnClickOutside(wrapperRef, handleSubmitValue)

  useEffect(() => {
    if (!isSidebarFilter) {
      handleSubmitValue()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enterWasPressed, isSidebarFilter])

  useEffect(() => {
    if (isSidebarFilter) {
      handleSubmitValue()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localValue, isSidebarFilter])

  // This clears selection when we run propertiesListStore.resetFilters
  useEffect(() => {
    if (initialValue === undefined) {
      setLocalValue(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])

  const handleOnClear = () => {
    onChange(false)
    setLocalValue(false)
  }

  return (
    <FilterAccordion
      title={title}
      onClearFilter={handleOnClear}
      ref={wrapperRef}
      filterValue={localValue}
      isSidebarFilter={isSidebarFilter}
    >
      <ToggleField>
        <ToggleField.Option
          label={`${title}-toggle`}
          onChange={() => setLocalValue(true)}
          value
          defaultChecked={initialValue}
          id={`${title}-yes`}
          title="Yes"
        />
        <ToggleField.Option
          label={`${title}-toggle`}
          onChange={() => setLocalValue(false)}
          value={false}
          defaultChecked={initialValue === false}
          id={`${title}-no`}
          toggleType={ToggleBooleanType.false}
          title="No"
        />
      </ToggleField>
    </FilterAccordion>
  )
}
